export default "__VITE_ASSET__CgDBbDHa__"